module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0035.jpg?v=6c0b99e9";